import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d37d346"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CheckIn" }
const _hoisted_2 = { class: "bg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CheckInNum" }, null, -1))
const _hoisted_4 = { class: "miaodou" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("苗豆")
const _hoisted_6 = { class: "tips" }
const _hoisted_7 = { class: "checkInList" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "连续签到领积分", -1))
const _hoisted_9 = { class: "list" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = {
  key: 1,
  class: "text"
}
const _hoisted_12 = { class: "tabs" }
const _hoisted_13 = { class: "taskList" }
const _hoisted_14 = { class: "taskItem" }
const _hoisted_15 = { class: "taskInfo" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "desc" }
const _hoisted_18 = { class: "taskMiaoDou" }
const _hoisted_19 = { class: "taskBtn" }
const _hoisted_20 = { class: "taskList" }
const _hoisted_21 = { class: "taskItem" }
const _hoisted_22 = { class: "taskInfo" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = {
  class: "taskMiaoDou",
  style: {"flex":"none"}
}
const _hoisted_25 = { class: "recordItem" }
const _hoisted_26 = { class: "recordInfo" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "time" }
const _hoisted_29 = { class: "recordMiaoDou" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanTab = _resolveComponent("VanTab")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanTabs = _resolveComponent("VanTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString($setup.taskStatus.points || 0), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, "明天签到可赚 " + _toDisplayString($setup.list[$setup.lastIndex==6?$setup.lastIndex:$setup.lastIndex+1]?.point || 0) + " 苗豆", 1),
      _createElementVNode("div", {
        class: "rule",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name:"MiaodouRule"})))
      }, "规则")
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "listItem",
            style: _normalizeStyle({color:item.signIn ? "#ffcc32" : ""})
          }, [
            _createElementVNode("div", _hoisted_10, "+" + _toDisplayString(item.point), 1),
            (item.signIn)
              ? (_openBlock(), _createBlock(_component_VanIcon, {
                  key: 0,
                  name: "checked",
                  size: "20",
                  color: "#ffcc32"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.getTime(item.time)), 1))
          ], 4))
        }), 256))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_VanTabs, {
        modelValue: $setup.active,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.active) = $event)),
        sticky: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VanTab, { title: "赚苗豆" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.taskList, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(item.desc), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, "+" + _toDisplayString(item.miaoDou), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_VanButton, {
                        color: "#fec64b",
                        size: "small",
                        round: "",
                        block: "",
                        disabled: $setup.taskStatus[item.field],
                        onClick: ($event: any) => ($setup.doTheTask(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.taskStatus[item.field]?item.finishBtn:item.btn), 1)
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])
                    ])
                  ]))
                }), 256))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_VanTab, { title: "花苗豆" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.spendList, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(item.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, "-" + _toDisplayString(item.miaoDou), 1)
                  ]))
                }), 256))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_VanTab, { title: "苗豆记录" }, {
            default: _withCtx(() => [
              _createVNode(_component_VanList, {
                class: "recordList",
                loading: $setup.loading,
                "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => (($setup.loading) = $event)),
                onLoad: $setup.loadMore,
                finished: $setup.finished,
                "immediate-check": false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.miaodouRecord, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, _toDisplayString(item.remarks), 1),
                        _createElementVNode("div", _hoisted_28, _toDisplayString(item.createTime), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, _toDisplayString(item.amount), 1)
                    ]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["loading", "onLoad", "finished"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}